import React,{useEffect,useState} from 'react';
import { Col, Container, Row } from 'react-bootstrap'
import * as AuthVerify from '../../lib/common';
import Axios from '../../lib/axios/axiosInstance';
import { Link } from "react-router-dom";

const ActiveCatalogue = () => {
  const [logedInUser, setLogedInUser] = useState(false);
  const [applycorpsetting, setApplycorpsetting] = useState(false);
  const [activeC, setActiveC] = useState(false);
  const [activeCC, setActiveCC] = useState(false);


  useEffect(async () => {
    const user=AuthVerify.getUser();
    if(user && user.role){
        setApplycorpsetting(user.applycorpsetting)
        setLogedInUser(user.role);
    //   api/account/costcenter
    if(user.applycorpsetting){
        await Axios.get(`/account/costcenter`)
        .then(async (data) => {
            var details=[];
            details.activeCC={};
            details.activeC={};
            if(data.data?.data?.length>0){
                data.data.data.map(item => {
                    if(item.active){
                        setActiveCC({
                            ccname:item.ccname,
                            ccnum:item.ccnum
                        });
                        item.catalogs.map((item)=>{
                            if(item.active){
                                setActiveC({
                                    cname:item.catalogname,
                                    cnum:item.catalognum
                                });
                            }
                        })
                    }
                })
            }
        })
    }
    }
  }, [])

    return (
        <>
        { logedInUser=='Corporate' && applycorpsetting && 
            <div className="header-top" style={{ background: "rgb(247, 164, 105)" }}>
                <Container>
                    <Row>
                        {/* <Col xs={12} sm={6}>
                            <div className="welcome-msg"></div>
                            {// <div className="dropdown jtv-language-box">
                                //     <a role="button" data-toggle="dropdown" data-target="#" className="block-language dropdown-toggle" href="#"> English <span className="caret"></span> </a>
                                //     <ul className="dropdown-menu" role="menu">
                                //         <li> <a className="selected" href="#"> <span>English</span> </a> </li>
                                //         <li> <a href="#"> <span>Chinese</span> </a> </li>
                                //         <li> <a href="#">
                                //             <img src="images/flag-german.jpg" alt="flag">
                                //                 <span>German</span> </a> </li>
                                //         <li> <a href="#">
                                //             <img src="images/flag-brazil.jpg" alt="flag">
                                //                 <span>Brazil</span> </a> </li>
                                //         <li> <a href="#">
                                //             <img src="images/flag-chile.jpg" alt="flag">
                                //                 <span>Chile</span> </a> </li>
                                //         <li> <a href="#">
                                //             <img src="images/flag-spain.jpg" alt="flag">
                                //                 <span>Spain</span> </a> </li>
                                //     </ul>
                                // </div>
                                // <div className="dropdown jtv-currency-box">
                                //     <a role="button" data-toggle="dropdown" data-target="#" className="block-currency dropdown-toggle" href="/"> SGD <span className="caret"></span></a>
                                //     <ul className="dropdown-menu" role="menu">
                                //         <li><a href="/"> $ - SGD </a> </li>
                                //         <li><a href="/"> $ - USD </a> </li>
                                //         <li><a href="/"> £ - Pound </a> </li>
                                //         <li><a href="/"> € - Euro </a> </li>
                                //     </ul>
                                // </div>
                            }
                        </Col> */}
                        <Col xs={12}>
                            <div className="jtv-top-links">
                                <div className="links">
                                    <ul>
                                        <li>
                                            <span>Active Cost Center:
                                                <strong style={{ color: "#395a98" }}>
                                                <Link to={activeCC ? `/costcenter-details?ccnum=${activeCC.ccnum}`:'/#'} style={{ padding: "0 15px 0 0",color:"blue",fontWeight:"bold",fontSize:"14px",cursor:"pointer" }}>&nbsp;{ activeCC ? activeCC.ccname : "No Active Cost Center Found !" }</Link></strong>
                                                </span>
                                        </li>
                                        <li>
                                            <span>Active Catalog: 
                                            <strong style={{ color: "#395a98" }}>
                                                <Link to={activeC ? `/catalog-details?catalognum=${activeC.cnum}`:'/#'} style={{ padding: "0 15px 0 0",color:"blue",fontWeight:"bold",fontSize:"14px",cursor:"pointer" }}>&nbsp;{ activeC ? activeC.cname : "No Active Catalog Found !" }</Link></strong>
                                                </span>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </Col>
                    </Row>
                </Container>
            </div>
        }</>
    )
}

export default ActiveCatalogue